// @ts-nocheck
/*
 * Port of components/partials/dashboard/release-center/releaseImport.js (84L).
 * BYTE-IDENTICAL — dynamic-imports mammoth for .docx and pdfjs-dist for .pdf.
 *
 * V1 QUIRK preserved: pdfjs worker path uses
 * `${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs` (CRA convention).
 * v2 is Vite — `process.env.PUBLIC_URL` is undefined so the effective
 * URL becomes `/pdf.worker.min.mjs`, which is fine when the worker sits
 * at project public/. Kept verbatim to avoid drift.
 */
const escapeHtml = (s: any) =>
  String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

// Turn bare URLs in plain text into anchor tags.
const linkify = (text: any) =>
  escapeHtml(text).replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  );

const readAsArrayBuffer = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });

async function importDocx(file: any) {
  const mammoth: any = await import('mammoth');
  const arrayBuffer: any = await readAsArrayBuffer(file);
  const result: any = await mammoth.convertToHtml({ arrayBuffer });
  return { html: result.value || '', warnings: result.messages || [] };
}

async function importPdf(file: any) {
  const pdfjs: any = await import('pdfjs-dist/build/pdf.min.mjs');
  pdfjs.GlobalWorkerOptions.workerSrc = `${
    (typeof process !== 'undefined' && process.env?.PUBLIC_URL) || ''
  }/pdf.worker.min.mjs`;

  const data: any = await readAsArrayBuffer(file);
  const pdf: any = await pdfjs.getDocument({ data }).promise;

  const paragraphs: any[] = [];
  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const content = await page.getTextContent();
    let line = '';
    const lines: any[] = [];
    content.items.forEach((item: any) => {
      line += item.str;
      if (item.hasEOL) {
        lines.push(line.trim());
        line = '';
      }
    });
    if (line.trim()) lines.push(line.trim());
    lines
      .filter((l: any) => l.length)
      .forEach((l: any) => paragraphs.push(l));
  }

  const html = paragraphs.length
    ? paragraphs.map((p: any) => `<p>${linkify(p)}</p>`).join('')
    : '';
  return { html, warnings: [] };
}

export async function extractContentFromFile(file: any) {
  if (!file) throw new Error('No file provided');
  const name = (file.name || '').toLowerCase();
  const type = file.type || '';

  if (name.endsWith('.docx') || type.includes('wordprocessingml')) {
    return { ...(await importDocx(file)), kind: 'docx' };
  }
  if (name.endsWith('.pdf') || type === 'application/pdf') {
    return { ...(await importPdf(file)), kind: 'pdf' };
  }
  if (name.endsWith('.doc')) {
    throw new Error(
      "Legacy .doc isn't supported — please save as .docx or PDF.",
    );
  }
  throw new Error('Unsupported file. Upload a PDF or Word (.docx) file.');
}
